import { useEffect } from "react";

import { useFlippers } from "@shared/context/FlippersContext";
import { getFingerprintHeader } from "@shared/helpers/getFingerprintHeader/getFingerprintHeader";

const PreloadFingerprint = () => {
  const [iamTrustedDeviceEnabled] = useFlippers("iam_trusted_device");

  useEffect(() => {
    if (!iamTrustedDeviceEnabled) {
      return;
    }

    const preloadFingerprint = async () => {
      await getFingerprintHeader();
    };

    preloadFingerprint().catch(() => {
      // ignore errors
    });
  }, []);

  return null;
};

export { PreloadFingerprint };
